import React from 'react'
import styled from 'styled-components'
import Helmet from 'react-helmet'
import Input from "../../Components/SearchInput";
import NormalText from '../../Components/NormalText';
import Button from '../../Components/Button';
import { media } from '../../styles/Mixin';
import Loader from "../../Components/Loader";
import AdfitWebComponent from "react-adfit-web-component";
import { Link } from 'react-router-dom'
import CommentBox  from '../../Components/CommentBox';

export default({
    onSubmit,
    videoLink,
    search,
    commentThread,
    loading,
    existToken,
    scroll,
    existError,
    check,
    GuidanceClick,
    array,
    moreData,
})=>{
  const configObject = {
    adType: "text/javascript",
    adUnit: "DAN-qdw2blz70p4h",
    adWidth: "100",
    adHeight: "50",
  };
    return (
      <Wrapper>
        <form onSubmit={onSubmit}>
          <Helmet>
            <title>That글</title>
          </Helmet>
          <Header>
            <HeaderColumn></HeaderColumn>
            <HeaderColumn></HeaderColumn>
            <HeaderColumn></HeaderColumn>
          </Header>
          <ContainerBox>
            <GuidanceBox>
              {/* <ChannelSearchBox to={`/search`}>
                <div>👋</div>
                <NormalText text={"채널 놀러가기!"} />
              </ChannelSearchBox> */}
              <GuidanceText
                text={"문의: trumis@naver.com"}
                // onClick={GuidanceClick}
              />
            </GuidanceBox>
            <VideoLinkBox>
              <Input
                placeholder={"검색할 비디오의 링크를 붙여주세요 🔗"}
                required={true}
                {...videoLink}
              />
            </VideoLinkBox>
            <SearchBox>
              <Input placeholder={"검색어를 입력해 주세요 😀"} {...search} />
            </SearchBox>
            <ButtonColumn>
              <SearchButton text={"검색"} backgroundColor={"blue"} />
              {check && array.length < 10 && !scroll && existToken && (
                <MoreSearchButton
                  type={"button"}
                  text={"아직 댓글이 더 남아있습니다. 더불러오기!"}
                  backgroundColor={"blue"}
                  loading={loading}
                  onClick={moreData}
                />
              )}
            </ButtonColumn>
            <ButtonColumn>
              <AdfitWebComponent {...configObject} />
            </ButtonColumn>
            <CommentContentsBox>
              {/* <SaveInCategoryWindow /> */}
              {commentThread.map(
                (comment, index) =>
                  comment.snippet.topLevelComment.snippet.textOriginal.includes(
                    search.value
                  ) && (
                    <CommentBox
                      key={index}
                      comment={comment}
                      topProfileImage={comment.snippet.topLevelComment.snippet.authorProfileImageUrl}
                      topAuthorName={comment.snippet.topLevelComment.snippet.authorDisplayName}
                      topCommentText={comment.snippet.topLevelComment.snippet.textOriginal}
                      id={comment.snippet.topLevelComment.id}
                      replyCount={comment.snippet.totalReplyCount}
                      reComments={comment.snippet.totalReplyCount > 0 && comment.replies.comments}
                    />
                  ))
                }
            </CommentContentsBox>
            <AnnounceColumn>
              {loading && <Loader />}
              {existToken === false && (
                <NormalText text={"더 이상 댓글이 존재하지 않습니다 😅"} />
              )}
              {existError === true && (
                <NormalText
                  text={"올바른 링크를 입력해주시거나 다시 검색해주세요 😅"}
                />
              )}
            </AnnounceColumn>
          </ContainerBox>
        </form>
      </Wrapper>
    );
}


const Wrapper = styled.div`
  width:100%;
`
const Header = styled.header`
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  padding:20px;
`

const HeaderColumn = styled.div`
  display:flex;
  flex-direction:row;
  justify-content:center;
`

const ContainerBox = styled.div`
  padding-top: 50px;
  width:100%;
  display: flex;
  flex-direction:column;
  align-items:center; 
`;
const GuidanceBox = styled.div`
  width:100%;
  display:flex;
  flex-direction:column;
  align-items:center;
  margin-bottom:20px;
`
const ChannelSearchBox = styled(Link)`
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content:center;
  text-decoration:none;
  color:black;
  &>:first-child{
    margin-right:10px;
    border-radius:50%;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    background-color:#DFE7EB;
    ${media.deskTop`
    font-size:30px;
    width:50px;
    height:50px;
    `}
    ${media.mobile`
    font-size:20px;
    width:30px;
    height:30px;
    `}
  }
`

const GuidanceText = styled(NormalText)`
  display: flex;
  justify-content:center;
  margin-top:15px;
  color:${props => props.theme.blueColor};
  &:hover{
    cursor: pointer;
  }
`;


const VideoLinkBox = styled.div`
  width: 100%;
  display:flex;
  flex-direction:row;
  justify-content:center;
  margin-bottom:20px;
`;

const SearchBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content:center;
  margin-bottom:15px;
`;

const CommentContentsBox = styled.div`
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  padding: 0px 10px 0px 10px;
  width:100%;
  ${media.deskTop`max-width:32%;`}
`
// const CommentInfoBox = styled.div`
//   display:flex;
//   flex-direction:row;
//   justify-content:flex-start;
//   margin-bottom:15px;
// `
// const AuthorDisplayName = styled(NormalText)`
//   font-weight:bold;
// `

// const TextDisplay = styled(NormalText)`

// `

// const AvatarColumn = styled.div`
//   display:flex;
//   flex-direction:column;
//   margin-right:10px;
// `

// const InfoColumn = styled.div`
//   display:flex;
//   flex-direction:column;
// `
// const ReCommentBox = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: flex-start;
//   margin: 15px 0px 15px 0px;
// `;

const ButtonColumn = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  ${media.deskTop`max-width:32%;`}
  margin-bottom:15px;
  width:100%;
  &>:first-child{
    margin-bottom:15px;
  }
`
const SearchButton = styled(Button)`
`

const MoreSearchButton = styled(Button)`
`;
const AnnounceColumn = styled.div`
  @media screen and (min-width: 501px) {
    max-width: 32%;
  }
`;